// The rows in the taxonomy's order. Webflow's list order is newest first.

import type { LayerRecipe } from '../../build-config';

export const PLAN_ROW = ['the-coupe', 'the-grande', 'the-kombi-coupe'];
export const ROOF_ROW = ['slope', 'wedge', 'gable'];
export const SIDING_ROW = ['split', 'classic', 'wrap'];
export const STYLE_ROW = ['scout', 'fjord', 'aero'];

export const planLayer: LayerRecipe = { id: 'plan', from: 'plan', options: PLAN_ROW };
export const roofLayer: LayerRecipe = { id: 'roof', from: 'roof', options: ROOF_ROW };
export const sidingLayer: LayerRecipe = { id: 'siding', from: 'siding', options: SIDING_ROW };
export const styleLayer: LayerRecipe = { id: 'style', from: 'style', options: STYLE_ROW };
